import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { movementSearchSchema } from '../../features/inventory/search'
import { StockMovementsPage } from '../../features/inventory/stock-movements-page'

export const Route = createFileRoute('/_app/stock-movements')({
  staticData: { crumb: 'stockMovements' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.read'),
  validateSearch: movementSearchSchema,
  component: StockMovementsPage,
})
